const TOOLS_ROUTE = [
  {
    path: 'tools/profit-calculation',
    name: 'profitCalculation',
    component: () => import('@/views/tools/profitCalculation'),
    meta: {
      title: '利润测算',
      icon: '',
      keepAlive: false,
    },
  },
  {
    path: 'tools/final-fee-calc',
    name: 'CalcFinalFee',
    component: () => import('@/views/tools/final-fee-calc/index.vue'),
    meta: {
      title: '尾程费用试算',
      icon: '',
      keepAlive: false,
    },
  },

  {
    path: 'tools/create-style-code',
    name: 'CreateStyleCode',
    component: () => import('@/views/tools/create-style-code'),
    meta: {
      title: '款式代码生成器',
      icon: '',
      keepAlive: false,
    },
  },
  {
    path: 'tools/oss-upload',
    name: 'OssUpload',
    component: () => import('@/views/tools/oss-upload'),
    meta: {
      title: 'OSS上传',
      icon: '',
      keepAlive: false,
    },
  },
  {
    path: 'tools/outer-box-label',
    name: 'outer-box-label',
    component: () => import('@/views/tools/outer-box-label'),
    meta: {
      title: 'GPSR标签生成',
      icon: '',
      keepAlive: false,
    },
  },
  {
    path: 'tools/profit-calculating',
    name: 'profitCalculating',
    component: () => import('@/views/tools/profit-calculating'),
    meta: {
      title: '利润测算2',
      icon: '',
      keepAlive: false,
    },
  },
  {
    path: 'tools/create-outerbox-label',
    name: 'CreateOuterboxLabel',
    component: () => import('@/views/tools/create-outerbox-label'),
    meta: {
      title: '外箱标签',
      icon: '',
      keepAlive: false,
    },
  },
]

export default TOOLS_ROUTE
